import React from 'react';
import { Music2, ShieldCheck, BarChart3, Megaphone, Check } from 'lucide-react';
import { services } from '../mock';

const iconMap = { Music2, ShieldCheck, BarChart3, Megaphone };

const Services = () => {
  return (
    <section id="services" className="relative py-24 lg:py-32 overflow-hidden">
      {/* subtle golden orb */}
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[700px] h-[700px] rounded-full bg-[#D4A94F]/[0.04] blur-[100px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        {/* Section header */}
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <div className="inline-block px-4 py-1.5 rounded-full border border-[#D4A94F]/30 bg-[#D4A94F]/5 mb-5">
            <span className="text-xs font-medium tracking-widest uppercase text-[#E9C46A]">
              Layanan Kami
            </span>
          </div>
          <h2 className="text-white font-bold text-4xl md:text-5xl leading-tight tracking-tight mb-5">
            Solusi Lengkap untuk
            <br />
            <span className="gold-gradient-text">Karir Musik Anda</span>
          </h2>
          <p className="text-neutral-400 text-lg leading-relaxed">
            Dari distribusi ke platform global hingga perlindungan hak cipta,
            kami hadir untuk mendukung setiap langkah perjalanan musik Anda.
          </p>
        </div>

        {/* Service cards */}
        <div className="grid md:grid-cols-2 gap-6">
          {services.map((service, i) => {
            const Icon = iconMap[service.icon];
            return (
              <div
                key={service.title}
                className="group relative bg-[#0f0f0f] border border-white/[0.06] hover:border-[#D4A94F]/40 rounded-3xl p-8 lg:p-10 card-transition hover:-translate-y-1 overflow-hidden"
              >
                {/* Gold accent corner */}
                <div className="absolute -top-20 -right-20 w-40 h-40 rounded-full bg-[#D4A94F]/[0.06] blur-2xl group-hover:bg-[#D4A94F]/[0.12] btn-transition" />

                <div className="relative">
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#E9C46A]/20 to-[#B8892C]/10 border border-[#D4A94F]/30 flex items-center justify-center mb-6 group-hover:from-[#E9C46A] group-hover:to-[#D4A94F] btn-transition">
                    <Icon className="w-6 h-6 text-[#E9C46A] group-hover:text-black btn-transition" strokeWidth={2} />
                  </div>

                  <h3 className="text-white font-bold text-2xl mb-3 tracking-tight">
                    {service.title}
                  </h3>
                  <p className="text-neutral-400 leading-relaxed mb-6">
                    {service.description}
                  </p>

                  <ul className="space-y-2.5">
                    {service.features.map((f) => (
                      <li key={f} className="flex items-center gap-3 text-sm text-neutral-300">
                        <span className="flex-shrink-0 w-5 h-5 rounded-full bg-[#D4A94F]/15 flex items-center justify-center">
                          <Check className="w-3 h-3 text-[#E9C46A]" strokeWidth={3} />
                        </span>
                        {f}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
